<div class="table-container">
  <agr-table-v2 matSort [dataSource]="dataSource" class="requests-overview__table-spaced-cols">
    @if (isGlobalAdministrator()) {
      <ng-container matColumnDef="customerName">
        <th class="text--bold text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'dashboard.overview-table.table-headers.customerName' | translate }}
        </th>
        <td
          class="text--left"
          mat-cell
          [attr.aria-label]="'dashboard.overview-table.table-headers.customerName' | translate"
          *matCellDef="let row"
        >
          {{ row.customerName }}
        </td>
      </ng-container>
    }

    @if (isGlobalAdministrator()) {
      <ng-container matColumnDef="contactInformation">
        <th class="text--bold text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'dashboard.overview-table.table-headers.contactInformation' | translate }}
        </th>
        <td
          class="text--left"
          mat-cell
          [attr.aria-label]="
            'dashboard.overview-table.table-headers.contactInformation' | translate
          "
          *matCellDef="let row"
        >
          {{ row.contactInformation }}
        </td>
      </ng-container>
    }

    @if (isGlobalAdministrator()) {
      <ng-container matColumnDef="shipToAddress">
        <th class="text--bold text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'dashboard.overview-table.table-headers.shipToAddress' | translate }}
        </th>
        <td
          class="text--left"
          mat-cell
          [attr.aria-label]="'dashboard.overview-table.table-headers.shipToAddress' | translate"
          *matCellDef="let row"
        >
          {{ row.shipToAddress }}
        </td>
      </ng-container>
    }

    <ng-container matColumnDef="manureCategory">
      <th class="text--bold text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.manureCategory' | translate }}
      </th>
      <td
        class="text--bold"
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.manureCategory' | translate"
        *matCellDef="let row"
      >
        {{ 'manureCategories.' + row.manureCategory | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="manureType">
      <th class="text--bold text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.manureType' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.manureType' | translate"
        *matCellDef="let row"
      >
        {{ 'manureTypes.' + row.manureType | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="amountInTons">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.amountInTons' | translate }}
      </th>
      <td
        class="text--bold text--left"
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.amountInTons' | translate"
        *matCellDef="let row"
      >
        {{ row.amountInTons }}
      </td>
    </ng-container>

    <ng-container matColumnDef="nKgPerTon">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.nKgPerTon' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.nKgPerTon' | translate"
        *matCellDef="let row"
      >
        {{ row.nKgPerTon | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="maxNitrogen">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.maxNitrogen' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.maxNitrogen' | translate"
        *matCellDef="let row"
      >
        {{ row.maxNitrogen | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="pKgPerTon">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.pKgPerTon' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.pKgPerTon' | translate"
        *matCellDef="let row"
      >
        {{ row.pKgPerTon | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="maxPhosphate">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.maxPhosphate' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.maxPhosphate' | translate"
        *matCellDef="let row"
      >
        {{ row.maxPhosphate | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="kKgPerTon">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.kKgPerTon' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.kKgPerTon' | translate"
        *matCellDef="let row"
      >
        {{ row.kKgPerTon | number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="isHomogeneous">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.homogeneous' | translate }}
      </th>
      <td
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.homogeneous' | translate"
        *matCellDef="let row"
      >
        <div>
          @switch (row.isHomogeneous) {
            @case (true) {
              <p>{{ 'homogeneity.homogeneous' | translate }}</p>
            }
            @case (false) {
              <p>{{ 'homogeneity.notHomogenous' | translate }}</p>
            }
            @case (null) {
              <p>{{ 'homogeneity.empty' | translate }}</p>
            }
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="distance">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.distance' | translate }}
      </th>
      <td
        class="text--bold"
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.distance' | translate"
        *matCellDef="let row"
      >
        {{ 'distance.' + row.distance | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="desiredDeliveryPeriod">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.desiredDeliveryPeriod' | translate }}
      </th>
      <td
        class="text--bold"
        mat-cell
        [attr.aria-label]="
          'dashboard.overview-table.table-headers.desiredDeliveryPeriod' | translate
        "
        *matCellDef="let row"
      >
        {{
          row.desiredDeliveryPeriodFrom
            ? ('shorthand-months.' + row.desiredDeliveryPeriodFrom | translate)
            : ('' | translate)
        }}
        {{ row.desiredDeliveryPeriodFrom && row.desiredDeliveryPeriodTo ? '-' : '' }}
        {{
          row.desiredDeliveryPeriodTo
            ? ('shorthand-months.' + row.desiredDeliveryPeriodTo | translate)
            : ('' | translate)
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="paymentType">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.paymentType' | translate }}
      </th>
      <td
        mat-cell
        class="paymentType container"
        [attr.aria-label]="'dashboard.overview-table.table-headers.paymentType' | translate"
        *matCellDef="let row"
      >
        @if (row.paymentType === 'Pay') {
          <div class="you-receive-container text--center">
            {{ 'dashboard.overview-table.paymentType.Receive' | translate }}
          </div>
        } @else {
          <div class="you-pay-container text--center">
            {{ 'dashboard.overview-table.paymentType.Pay' | translate }}
          </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="pricePerTon">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.pricePerTon' | translate }}
      </th>
      <td
        class="text--bold"
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.pricePerTon' | translate"
        *matCellDef="let row"
      >
        {{ row.pricePerTon | currency: 'EUR' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalPrice">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dashboard.overview-table.table-headers.price' | translate }}
      </th>
      <td
        class="price-container"
        mat-cell
        [attr.aria-label]="'dashboard.overview-table.table-headers.price' | translate"
        *matCellDef="let row"
      >
        {{ row.totalPrice | currency: 'EUR' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th class="text--left" mat-header-cell *matHeaderCellDef mat-sort-header></th>
      <td mat-cell *matCellDef="let row">
        @if (row.status === 'MatchRequested') {
          <div
            class="match-requested-container flex--row flex--nowrap flex--justify-center flex--align-center"
          >
            {{ 'dashboard.overview-table.status.' + row.status | translate }}
            <div class="flex--row flex--align-center text-color--black text--small"></div>
          </div>
        }
        @if (row.status === 'MatchApproved') {
          <div
            class="match-requested-container flex--row flex--nowrap flex--justify-center flex--align-center"
          >
            <div class="text--center">
              {{ 'dashboard.overview-table.status.' + row.status | translate }}
            </div>
          </div>
        }
        @if (row.status === 'New' && row.customerId === selectedCustomerId()) {
          <div class="match-maken-container text--center">
            {{ 'dashboard.overview-table.status.' + row.status | translate }}
          </div>
        }
        @if (row.status === 'New' && row.customerId !== selectedCustomerId() && isCustomer()) {
          <div (click)="openRequestOverviewDialog(row)" class="match-maken-container text--center">
            {{ 'dashboard.overview-table.status.' + row.status | translate }}
          </div>
        }
      </td>
    </ng-container>

    <agr-table-top-bar *agrTableTopBar>
      <agr-table-selected-items></agr-table-selected-items>
      @if (isGlobalAdministrator()) {
        <div>
          <agr-export agrTableExport [options]="exportOptions" [dataSource]="dataSource">
          </agr-export>
        </div>
      }
    </agr-table-top-bar>

    <tr mat-header-row *matHeaderRowDef="displayColumns()"></tr>
    <tr mat-row *matRowDef="let myRowData; columns: displayColumns()"></tr>
  </agr-table-v2>
</div>
